import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class GrooveRecommendationStep2Service {
  private grooveRecommendation;
  private grooveRecommendationJis;
  constructor(private http: HttpClient) {}

  private getGrooveRecommendationStep2Data() {
    this.grooveRecommendation = this.http.get('assets/calculations-json/GrooveRecommendationStep2.json');
  }

  private getGrooveRecommendationJisStep2Data() {
    this.grooveRecommendationJis = this.http.get('assets/calculations-json/GrooveRecommendationStep2_jis.json');
  }

  getGrooveRecommendation() {
    if (!this.grooveRecommendation) {
      this.getGrooveRecommendationStep2Data();
    }
    return this.grooveRecommendation;
  }

  getGrooveRecommendationJis() {
    if (!this.grooveRecommendationJis) {
      this.getGrooveRecommendationJisStep2Data();
    }
    return this.grooveRecommendationJis;
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/service/GrooveRecommendationStep2Service.ts